import { createContext } from 'react';
export var settingsContextDefaultValue = {
    showRightMenu: false,
    showMobileMenu: false,
    showFilters: false,
    showChangelogMenu: false,
    setShowRightMenu: function () { return undefined; },
    setShowMobileMenu: function () { return undefined; },
    setShowFilters: function () { return undefined; },
    setShowChangelogMenu: function () { return undefined; },
};
export var SettingsContext = createContext(settingsContextDefaultValue);
